import React from "react";
import { createRoot } from "react-dom/client";
import "./css/bootstrap.min.css";
import "./css/font-awesome.min.css";
import "./css/style.css";
import App from "./views/App";
import store from "./store";
import { Provider } from "react-redux";

const container = document.getElementById("wrapper");
const root = createRoot(container)
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
